import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  acknowledgeCookieNotice,
  hasAcknowledgedCookieNotice,
} from "../cookie-preferences";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!hasAcknowledgedCookieNotice());
  }, []);

  const acknowledge = () => {
    acknowledgeCookieNotice();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside className="cookie-banner" aria-label="Cookie notice">
      <p>
        Medein stores your acknowledgement of this notice. Cloudflare may set a strictly necessary security cookie.
        Analytics and advertising cookies are not currently enabled.{" "}
        <Link to="/cookie-policy">Read the Cookie Policy</Link>
      </p>
      <button className="button button-primary button-small" onClick={acknowledge}>Acknowledge</button>
    </aside>
  );
}
